export default __webpack_public_path__ + "static/media/2022-09-16-Tiktok-Trackers-Policy.06a5d926.md";